module.exports = __webpack_public_path__ + "img/dice-6.0bb824fc.svg";